import React from 'react';
import { currySC, IFNTheme, registerClass, cns } from '@food/css-manager';
import { DefaultLayout } from '../../utils/layout';
import { DefaultPageData, ILocation } from '../DefaultPageData';
import { TUserExtendedData } from '../UserExtendedData';

interface IDefaultPageProps {
	children: (args: {
		user: TUserExtendedData | null;
		location: ILocation;
		layout: DefaultLayout;
		history: any;
	}) => JSX.Element | null;
}

export const DefaultPageStyleClass = registerClass(
	(t: IFNTheme, sc) => `
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	padding: ${t.ratios.l * t.font.baseSize}px;
	
	.${sc('pageTitle')} {
		display: none;
	}

	.${sc('main')} {
		flex: 0 1 100%;
		padding: 0;
		max-width: 100%;
	}
	
	.${sc('mobileMenu')} {
		display: none;
	}

	&.${sc('layout', DefaultLayout.MOBILE)} {
		padding: 0;
		.${sc('mobileMenu')} {
			margin: ${t.ratios.l * t.font.baseSize}px auto 0;
			display: block;
		}

		.${sc('pageTitle')} {
			text-transform: uppercase;
			color: ${t.colors.alt.dark};
			font-weight: ${t.font.weights.bold};
			width: 100%;
			display: block;
		}
	}

  `,
);

const sc = currySC(DefaultPageStyleClass);

export const DefaultPage: React.FC<IDefaultPageProps> = ({ children }) => (
	<DefaultPageData>
		{({ user, location, layout, history }) => (
			<div className={cns(DefaultPageStyleClass, sc('layout', layout))}>
				<div className={sc('main')}>
					{children({ user, location, layout, history })}
				</div>
			</div>
		)}
	</DefaultPageData>
);
